import throttle from '~/utils/throttle';
import EventDelegate from '../utils/event-delegate.js';

const GATracking = (($, DM) => {

    const Attrs = {
        GA: 'data-ga',
        GA_SCROLL: 'data-ga-scroll', 
        GA_LABEL: 'data-ga-label',
        TITLE: 'title'
    };

    const THROTTLE_TIME = 100;

    let gaScrollElements = document.querySelectorAll(`[${Attrs.GA_SCROLL}]`);

    class GATracking {
        constructor() {
            this.gaScrollArray = [...gaScrollElements];
            this.throttledScroll = throttle(this.handleScroll.bind(this), THROTTLE_TIME);
            this.addEvents();
        }

        track(parameters) {
            if (parameters.label) {
                DM.Utils.trackEvents(parameters.category, parameters.action, parameters.label);
            } else {
                DM.Utils.trackEvents(parameters.category, parameters.action);
            }
        }

        prepareParameters(str, attrLabel) {
            var params = str.split('.');

            return {
                category: params[0],
                action: params[1] || 'click',
                label: params[2] || attrLabel
            };
        }

        prepareTrack(attrs, attrLabel) {
            attrs.split(',').forEach((str) => {
                const parameters = this.prepareParameters(str, attrLabel);
                this.track(parameters);
            });
        }

        allEmptyElements(array) {
            return array.every((element) => {
                return element === null;
            });
        }

        handleClickAttr(e) {
            const element = e.currentTarget;
            const attrGA = element.getAttribute(Attrs.GA).toLowerCase();
            const attrLabel = element.getAttribute(Attrs.GA_LABEL) || element.getAttribute(Attrs.TITLE) || null;

            this.prepareTrack(attrGA, attrLabel);
        }

        handleScroll() {
            this.gaScrollArray.forEach((element, index) => {
                if (element.getBoundingClientRect().top - window.innerHeight <= 0) {
                    const attrGA = element.getAttribute(Attrs.GA_SCROLL).toLowerCase();
                    const attrLabel = element.getAttribute(Attrs.GA_LABEL) || element.getAttribute(Attrs.TITLE) || null;

                    this.prepareTrack(attrGA, attrLabel);
                    this.gaScrollArray.splice(index, 1);
                }
            });

            if (this.allEmptyElements(this.gaScrollArray)) {
                window.removeEventListener('scroll', this.throttledScroll, {
                    passive: true,
                    capture: true
                });
            }
        }

        addEvents() {
            const delegate = new EventDelegate(document);
            delegate.on('click', `[${Attrs.GA}]`, this.handleClickAttr.bind(this));

            if (this.gaScrollArray.length !== 0) {
                window.addEventListener('scroll', this.throttledScroll, {
                    passive: true,
                    capture: true
                });
            }
        }
    }

    return new GATracking();

})(window.jQuery, window.DM);

export default GATracking;
